import type { Property } from "@/store/v2/currentProperty/selectors";

export const getPropertyMenuItems = (property: Property) => {
  return {
    propertyMenuItems: property.propertyMenuItems,
  };
};
